import React, { useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";

import { buildMuscleRegionEvolutionChartModel } from "./muscle-region-evolution-chart";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler
);

const MuscleRegionEvolutionPanel = ({ row }) => {
  const chartModel = useMemo(
    () =>
      buildMuscleRegionEvolutionChartModel({
        timeline: row?.timeline || [],
        unit: row?.unit || "cm",
        trend: row?.trend || "flat",
        progressTone: row?.progressTone || "medium",
        regionLabel: row?.regionLabel || "",
      }),
    [row]
  );

  if (!row) {
    return null;
  }

  return (
    <div className="anthropometry-detailed-progress__region-evolution-panel">
      <div className="anthropometry-detailed-progress__region-evolution-panel__header">
        <h3>Evolução — {row.regionLabel}</h3>
        <p>Valores em {row.unit} no período selecionado</p>
      </div>

      {chartModel.hasValues ? (
        <div className="anthropometry-detailed-progress__region-evolution-chart">
          <Line data={chartModel.chartData} options={chartModel.chartOptions} />
        </div>
      ) : (
        <div className="anthropometry-detailed-progress__panel-empty anthropometry-detailed-progress__panel-empty--compact">
          <p>Não há dados suficientes para exibir a evolução desta área.</p>
        </div>
      )}
    </div>
  );
};

export default MuscleRegionEvolutionPanel;
